import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
    selectPersonalAccidentCurrentStepIndex, 
    selectPersonalAccidentCurrentSubstepIndex, 
    selectPersonalAccidentFlowType, 
    setCurrentStepIndex, 
    setCurrentSubstepIndex, 
    setFlowType 
} from '../redux/features/personalAccidentFlowSlice';
import { new_personal_accident_flow } from './data';

const usePersonalAccidentFlow = () => {
    const dispatch = useDispatch();
    const flowType = useSelector(selectPersonalAccidentFlowType);
    const currentStepIndex = useSelector((state) => selectPersonalAccidentCurrentStepIndex(state));
    const currentSubstepIndex = useSelector((state) => selectPersonalAccidentCurrentSubstepIndex(state));

    const steps = new_personal_accident_flow[flowType] || [];
    const currentStep = steps[currentStepIndex] || {};
    const currentSubstep = currentStep.substeps ? currentStep.substeps[currentSubstepIndex] : '';

    const handleFlowChange = (type, currentStepIndex, currentSubstepIndex) => {
        dispatch(setFlowType({ type, currentStepIndex, currentSubstepIndex }));
    };

    const handleNextSubstep = () => {
        if (currentStep.substeps && currentSubstepIndex < currentStep.substeps.length - 1) {
            dispatch(setCurrentSubstepIndex(currentSubstepIndex + 1));
        }
        else if (currentSubstepIndex === currentStep.substeps.length - 1) {
            handleNextStep();
        }
    };

    const handlePrevSubstep = () => {
        if (currentSubstepIndex > 0) {
            dispatch(setCurrentSubstepIndex(currentSubstepIndex - 1));
        }
        else {
            handlePrevStep();
        }
    };

    const handleNextStep = () => {
        if (currentStepIndex < steps.length - 1) {
            dispatch(setCurrentStepIndex(currentStepIndex + 1));
        }
    };

    const handlePrevStep = () => {
        if (currentStepIndex > 0) {
            const previousStep = steps[currentStepIndex - 1] || {};
            const substepIndex = previousStep?.substeps?.length - 1 || 0;
            dispatch(setCurrentStepIndex(currentStepIndex - 1));
            dispatch(setCurrentSubstepIndex(substepIndex));
        }
    };

    return {
        handleFlowChange,
        handleNextSubstep,
        handlePrevSubstep,
        handleNextStep,
        handlePrevStep,
        flowType,
        steps,
        currentStep,
        currentStepIndex,
        currentSubstep,
        currentSubstepIndex,
    };
};

export default usePersonalAccidentFlow;